import { render, staticRenderFns } from "./OrgaoNew.vue?vue&type=template&id=afe01d60&scoped=true&"
import script from "./OrgaoNew.vue?vue&type=script&lang=js&"
export * from "./OrgaoNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe01d60",
  null
  
)

export default component.exports